export default __webpack_public_path__ + "static/media/Cheese-Web-4.9c72ee2f.png";